import { theme } from '@eneco/sparky/theme';
import { HeadingProps } from '@eneco/sparky/types';
import { DynamicPricingTariffsRendering } from '@sitecore/types/DynamicPricingTariffs';

export const graphViewOptions = ['day', 'week', 'month', 'year'] as const;

export const graphColors = {
  cheapTariff: theme.colors.iconElectricity,
  expensiveTariff: theme.colors.feedbackError,
  averagePrice: theme.colors.feedbackInfo,
  unknownPrice: theme.colors.graphsEstimatedPrimary,
  gasProduct: theme.colors.graphsGasPrimary,
  electricityProduct: theme.colors.iconElectricity,
  backgroundDark: theme.colors.backgroundDark,
  textInverted: theme.colors.textInverted,
} as const;

export const headingSizes: Record<DynamicPricingTariffsRendering['params']['headingSize'], HeadingProps['size']> = {
  headingDefault: {
    initial: 'M',
    md: 'L',
  },
  headingHero: {
    initial: 'M',
    md: 'XL',
  },
  headingSub: {
    initial: 'S',
    md: 'M',
  },
} as const;
export const graphProductOptions = ['electricity', 'gas'] as const;
